<template>
  <div class="page">
    <el-form
            v-if="isSearch"
            :model="queryForm"
            ref="form"
            label-width="80px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >
          <el-form-item label="所属账号">
                <GridSelectU style="width: 200px;" title="选择所属账号" labelName="userName"
                             labelValue="id" :value="queryForm.userId" :limit='1' size='small'
                             placeholder='请选择所属账号'
                             @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search"
                             dataListUrl="/mpp/user/findList" entityBeanName="mppUser"
                             queryEntityUrl="/mpp/user/get">
                </GridSelectU>
            </el-form-item>
         <el-form-item label="营业执照名称" label-width="120px">
                 <el-input v-model="queryForm.licenseName" placeholder="请输入营业执照名称" style="width: 250px"></el-input>
            </el-form-item>
         <el-form-item label="营业执照编号" label-width="120px">
                 <el-input v-model="queryForm.licenseNumber" placeholder="请输入营业执照编号" style="width: 180px"></el-input>
            </el-form-item>
           <el-form-item label="组织类型">
                <el-select clearable v-model="queryForm.orgType" style="width: 100px;">
                    <el-option v-for="(item,index) in storeOrgTypeStatusEunmList" :key="index" :value="item.value" :label="item.label"></el-option>
                </el-select>
            </el-form-item>
   
            <el-form-item label="法人姓名">
                <el-input v-model="queryForm.personName" placeholder="请输入姓名" style="width: 100px"></el-input>
            </el-form-item>
            <el-form-item label="法人手机号" label-width="100px"  >
                <el-input v-model="queryForm.personMobile" placeholder="请输入手机号" style="width: 180px"></el-input>
            </el-form-item>
            <el-form-item style="margin-left: 80px">
                <el-button size="small" type="primary" icon="el-icon-search" @click="getBrandList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
    <div class="page-content">
      <div class="page-tool-bar">
        <div class="operation">
        </div>
        <div class="icon-group">
            <span title="搜索" class="icon-box" @click="search">
                <Icon color="#606266">
                    <Search />
                </Icon>
            </span>
            <span class="icon-box" @click="refreshShopMoneyFlowList">
                <Icon color="#606266">
                    <Refresh />
                </Icon>
            </span>
        </div>
      </div>
      <!-- 列表数据 -->
      <el-table
        height='100%'
        :data="shopBrandList"
        row-key="id"
        @selection-change="handleSelectionChange"
        size="small"
        border
        v-loading="loading"
      >
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="orgType"
          label="组织类型"
          width="150px"
        >
            <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.orgType == 1">小微</el-tag>
            <el-tag  v-if="scope.row.orgType == 2">企业</el-tag>
            <el-tag type="danger" v-if="scope.row.orgType == 3">个体</el-tag>
            </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="licenseName"
          label="营业执照名称"
          width="200px"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="addressMatchDesc"
          label="地址异常信息"
          width="200px"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="huiFuJjStatusName"
          label="进件状态"
          width="200px"
        >
        <template slot-scope="scope">
          <div style="color: #f4a715;" v-if="scope.row.huiFuJjStatusName == '待进件'"> 
                  待进件
            </div>
            <div style="color: coral;" v-if="scope.row.huiFuJjStatusName == '审核中'">
                 审核中
            </div>
            <div style="color: #44c90d;" v-if="scope.row.huiFuJjStatusName == '进件成功'"> 
                 进件成功
            </div>
            <div style="color: crimson;" v-if="scope.row.huiFuJjStatusName == '审核不通过'"> 
                 审核不通过
            </div>
        </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="huiFuJjMsg"
          label="进件错误信息"
          width="200px"
        >
        <template slot-scope="scope">
          {{scope.row.huiFuJjMsg ? scope.row.huiFuJjMsg : '--'}}
        </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="formStatusName"
          label="业务开通状态"
          width="200px"
        >
            <template slot-scope="scope">
                <div style="color: #f4a715;" v-if="scope.row.formStatusName == '审核中'">
                    审核中
                </div>
                <div style="color: #44c90d;" v-if="scope.row.formStatusName == '审核通过'"> 
                    审核通过
                </div>
                <div style="color: crimson;" v-if="scope.row.formStatusName == '审核拒绝' || scope.row.formStatusName == '系统处理失败'"> 
                    {{scope.row.formStatusName}}
                </div>
            </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="formStatusDetail"
          label="业务开通描述"
          width="200px"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="huiFuId"
          label="商户号"
          width="200px"
        >
            <template slot-scope="scope">
                <span style="font-weight: bold;">{{ scope.row.huiFuId }}</span> 
                <i v-if="scope.row.huiFuId" class="el-icon-document-copy" style="cursor: pointer; color: #409EFF; margin-left: 8px;" @click="copyHuiFuId(scope.row.huiFuId)" title="复制"></i>
            </template>
        </el-table-column>
         <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="conStatName"
          label="签约状态"
          width="200px"
        >
            <template slot-scope="scope">
                <!-- {{scope.row.conStatName}} -->
                <el-tag v-if="scope.row.conStatName == '创建合同异常'">创建合同异常</el-tag>
                <el-tag v-if="scope.row.conStatName == '待签约'" type="warning">待签约</el-tag>
                <el-tag v-if="scope.row.conStatName == '签约中'" type="warning">签约中</el-tag>
                <el-tag v-if="scope.row.conStatName == '签约完成'" type="success">签约完成</el-tag>
                <el-tag v-if="scope.row.conStatName == '已失效'" type="danger">已失效</el-tag>
                <el-tag v-if="scope.row.conStatName == '已拒签'" type="danger">已拒签</el-tag>
                <el-tag v-if="scope.row.conStatName == '签约失败'" type="danger">签约失败</el-tag>
            </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="agreementLink"
          label="协议链接"
          width="200px"
        >
        <template slot-scope="scope">
          <a :href="scope.row.agreementLink" target="_blank" style="color: #409EFF;text-decoration: underline;">{{ scope.row.agreementLink }}</a>
        </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="aliConfStatusName"
          label="支付宝业务开通状态"
          width="200px"
        >
        </el-table-column>
         <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="aliConfReason"
          label="支付宝业务开通描述"
          width="200px"
        >
        <template slot-scope="scope">
            <div > 
              {{scope.row.aliConfReason ? scope.row.aliConfReason : '--'}}
            </div>
        </template>
         </el-table-column>
         <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="aliRealNameApplymentStatName"
          label="支付宝认证状态"
          width="200px"
        >
        <template slot-scope="scope">
            <div style="color: red;"> 
              {{scope.row.aliRealNameApplymentStatName}}
            </div>
        </template>
         </el-table-column>
         <el-table-column
          align="center"
          prop="aliQrcodeData"
          label="支付宝二维码"
          width="200px"
        >
        <template slot-scope="scope">
            <el-image 
                v-if="scope.row.aliQrcodeData"
                :src="scope.row.aliQrcodeData" 
                :preview-src-list="[scope.row.aliQrcodeData]"
                fit="cover"
                style="width: 80px; height: 80px;"
            />
            <div v-else style="display: flex;justify-content: center;">
                 <img src="@/assets/img/App.png"></img>                
            </div>
        </template>
        </el-table-column>
        <el-table-column
            align="center"
            prop="aliRealNameApplymentDesc"
            label="支付宝认证信息"
            width="200px"
            >
            <template slot-scope="scope">
                <div > 
                    {{scope.row.aliRealNameApplymentDesc ? scope.row.aliRealNameApplymentDesc : '--'}}
                </div>
            </template>
       </el-table-column>
       <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="wxConfStatus"
          label="微信业务开通状态"
          width="200px"
        >
        <template slot-scope="scope">
          <div > 
              <!-- 微信业务开通状态(0:处理中 1:成功 2:失败) -->
                {{scope.row.wxConfStatus == 0 ? '处理中' : scope.row.wxConfStatus == 1 ? '成功' : scope.row.wxConfStatus == 2 ? '失败' : '--' }}
            </div>
        </template>
       </el-table-column>
          <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="wxConfReason"
          label="微信业务开通描述"
          width="200px"
        >
        <template slot-scope="scope">
          <div > 
             {{scope.row.wxConfReason ? scope.row.wxConfReason : '--' }}
            </div>
        </template>
       </el-table-column>
       <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="wxRealNameApplymentStatName"
          label="微信认证状态"
          width="200px"
        >
        <template slot-scope="scope">
            <div style="color: red;"> 
                {{scope.row.wxRealNameApplymentStatName}}
            </div>
        </template>
       </el-table-column>
       <el-table-column
          align="center"
          prop="wxQrcodeData"
          label="微信二维码"
          width="200px"
        >
        <template slot-scope="scope">
            <el-image 
                v-if="scope.row.wxQrcodeData" 
                :src="scope.row.wxQrcodeData" 
                :preview-src-list="[scope.row.wxQrcodeData]"
                fit="cover"
                style="width: 80px; height: 80px;"
            />
             <div v-else style="display: flex;justify-content: center;">
                 <img src="@/assets/img/App.png"></img>                
            </div>
        </template>
        </el-table-column>
       <el-table-column
          align="center"
          prop="wxRealNameApplymentDesc"
          label="微信认证信息"
          width="200px"
        >
        <template slot-scope="scope">
            <div> 
                {{scope.row.wxRealNameApplymentDesc ? scope.row.wxRealNameApplymentDesc : '--'}}
            </div>
        </template>
       </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="personName"
          label="法人姓名"
          width="200px"
        >
       </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="personMobile"
          label="法人手机"
          width="200px"
        >
       </el-table-column>
       <el-table-column align="center" label="操作" width="300px" fixed="right">
            <template slot-scope="scop">
                 <div class="operation">
                    <div class="primary" style="background-color: #e7e7e7;color:#666666;" @click="checkShopStoreOrgInfo(scop.row)">查看</div>
                    <div class="primary" @click="editShopStoreOrgInfo(scop.row)">修改</div>
                    <div class="primary" v-if="scop.row.huiFuJjStatusName == '待进件'" @click="incoming(scop.row)" style="background-color:  #FF6356;">汇付进件</div>
                    <!-- <div class="primary"  type="primary" style="background-color:  #FF6356;" @click="merchantBusinessActivation(scop.row)">商户业务开通</div> -->
                    <div class="primary" style="background-color: #e66d0fe3 ;" type="primary" @click="merchantDisplay(scop.row)">注销商户</div>
                    <div class="primary" style="background-color: #00AC6A;" type="primary" @click="basicDataStatus(1,scop.row)">进件状态查询</div>
                    <div class="primary"  style="background-color: #7e57c2;" type="primary" @click="basicDataStatus(2,scop.row)">产品开通查询</div>
                    <div class="primary" v-if="scop.row.huiFuPay != 1" style="background-color: #00FFFF;color: #000;" type="primary" @click="addHFPayFn(scop.row)">加入汇付支付</div>
                    <div class="primary" v-if="scop.row.huiFuStatus == 1" style="background-color: #C71585;color: #fff;" type="primary" @click="addKFPayFn(scop.row)">加入快付支付</div>
                </div>
            </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          background
          :pager-count="7"
        >
        </el-pagination>
      </div>
    </div>

     <!-- 新增/查看/修改信息 -->
      <quickPayment v-if="drawer" :orgObj="orgObj" :storeObj="storeObj"   :drawer="drawer" :title="title"  @updateDrawer="updateDrawer" :disabled="disabled" ></quickPayment>
  </div>  
</template>

<script>
import { Refresh,  Search } from '@v2icons/tabler';
import { get, post, deleteFun, upload ,postJson } from '@/utils/request.js';
import { UPLOAD_API, UPLOAD_PATH, USER, USER_SEARCH } from '@/utils/constant';
import GridSelectU from '@/components/gridselect/index.vue';
import quickPayment  from './common/quickPayment.vue'
export default {
   components: {
    Refresh,
    Search,
    GridSelectU,
    quickPayment,
  },  
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopBrandList();
                this.getBrandList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopBrandList();
                this.getBrandList();
                this.$emit('resetCheckState');
            }
        },
         //市
        'shopStoreOrginfo.licenseProvinceId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getCity) {
                    this.shopStoreOrginfo.licenseCityId = '';
                    this.shopStoreOrginfo.licenseAreaId = '';
                    this.shopStoreOrginfo.licenseTownId = '';
                } else {
                    this.getCity = !this.getCity;
                }
                this.getAddress(2,id)
            }, 5);
        },
        //区
        'shopStoreOrginfo.licenseCityId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getArea) {
                    this.shopStoreOrginfo.licenseAreaId = '';
                    this.shopStoreOrginfo.licenseTownId = '';
                } else {
                    this.getArea = !this.getArea;
                }
                this.getAddress(3,id)
            }, 10);
        },
        //社区
        'shopStoreOrginfo.licenseAreaId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.street) {
                    this.shopStoreOrginfo.licenseTownId = '';
                } else {
                    this.street = !this.street;
                }
                this.getAddress(4,id)
            }, 15);
        },
        //市
        'shopStoreOrginfo.bankProvinceId'(id) {
            
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getCity2) {
                    this.shopStoreOrginfo.bankCityId = '';
                    this.shopStoreOrginfo.bankAreaId = '';
                    this.shopStoreOrginfo.bankTownId = '';
                } else {
                    this.getCity2 = !this.getCity2;
                }
                this.getAddress2(2,id)
            }, 25);
        },
        //区
        'shopStoreOrginfo.bankCityId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getArea2) {
                    this.shopStoreOrginfo.bankAreaId = '';
                    this.shopStoreOrginfo.bankTownId = '';
                } else {
                    this.getArea2 = !this.getArea2;
                }
                this.getAddress2(3,id)
            }, 30);
        },
        //社区
        'shopStoreOrginfo.bankAreaId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.street2) {
                    this.shopStoreOrginfo.bankTownId = '';
                } else {
                    this.street2 = !this.street2;
                }
                this.getAddress2(4,id)
            }, 35);
        },
        //市
        'shopStoreOrginfo.ysProvinceId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.ysGetCity) {
                    this.shopStoreOrginfo.ysCityId = '';
                    this.shopStoreOrginfo.ysAreaId = '';
                } else {
                    this.ysGetCity = !this.ysGetCity;
                }
                this.getAddressYs(2,id)
            }, 40);
        },
        //区
        'shopStoreOrginfo.ysCityId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.ysGetArea) {
                    this.shopStoreOrginfo.ysAreaId = '';
                } else {
                    this.ysGetArea = !this.ysGetArea;
                }
                this.getAddressYs(3,id)
            }, 50);
        },
        tabs(val){
              this.tabsVal = val  
            // switch (val) {
            if(val == 'zero'){
                this.queryForm.thirdStatus='';
                this.currentPage = 1;
                this.getShopStoreOrgInfoList();
                return
            }
            for (let i = 0; i < this.auditStatusList.length; i++) {
                if(val == 'status_'+i){
                    this.queryForm.thirdStatus = i;
                    this.currentPage = 1;
                    this.getShopStoreOrgInfoList();
                    break;
                }
            }
          
        }
    },
    data() {
        return {
            USER_code: USER,
            USER_search: USER_SEARCH,
            title: "进件详情",
            drawer: false,
            disabled: true,
            queryForm: {
                  userId:"",//用户ID
                  licenseNumber: "",
                  storeId: "",//门店ID
                  orgType: "", //组织类型：1小微 2企业 3个体
                  personName: "", //法人姓名
                  personMobile: "", //法人手机
                  signStatus: "", //签约状态
                  licenseName:"", //营业执照名称
                  licenseNumber:"", //营业执照编号
                 },
            storeOrgTypeStatusEunmList: [ 
                {
                    value: 1,
                    label: '小微',
                },
                {
                    value: 2,
                    label: '企业',
                },
                {
                    value: 3,
                    label: '个体',
                }
            ],
            disabledShow: false,
            timeRange: [],
            loading: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            multipleSelection: [],
            shopBrandList: [],//列表数据
            groupValue: [],
            waitMoney:null,
            orgObj: {}, // 组织信息
            storeObj: {}, // 店铺信息
            disabled: true,
            
            header: {
                token: localStorage.getItem('token')
            },
            action: UPLOAD_API + UPLOAD_PATH,
            currentShopStoreOrgInfoId: '',
            shopStoreOrginfoState:'edit',
            shopStoreOrginfoStates: {
                add: '新建进件资料',
                check: '查看进件资料',
                edit: '修改进件资料'
            },
            fileList: [],
            albumList: [],
            temporaryList: [],
            shopStoreOrginfo: {
                userId: '', //用户id
                storeId: '', //门店id
                subAccount: '', //子商户号
                orgType: '', //组织类型 1小微 2企业 3个体
                licensePic: '', //营业执照图片
                licenseProvinceId: '', //营业执照省
                licenseCityId: '', //营业执照市
                licenseAreaId: '', //营业执照区
                licenseTownId: '', //营业执照乡镇
                licenseName: '', //营业执照名称
                licenseAddress: '', //营业执照地址
                licenseNumber: '', //社会统一信用代码
                licenseStartTime: '', //营业执照有效开始日期
                licenseEndTime: '', //营业执照有效结束日期
                licenseRange: '', //营业执照经营范围
                personName: '', //法人姓名
                personMobile: '', //法人手机号
                idCard: '', //身份证号
                idCardStartTime: '', //身份证有效开始日期
                idCardEndTime: '', //身份证有效结束日期
                idCardFacade: '', //身份证正面图片
                idCardBack: '', //身份证背面图片
                idCardAddress: '', //身份证地址
                bankAccount: '', //银行账号
                bankHolder: '', //银行卡持有人
                bankMobile: '', //银行预留手机号
                bankCardFacade: '', //银行卡正面图片
                bankCardBack: '', //银行卡背面图片
                bankAccountVoucher: '', //对公账户凭证
                bankName: '', //银行名称
                bankSubbranch: '', //开户支行名称
                bankProvinceId: '', //开户行省
                bankCityId: '', //开户行市
                bankAreaId: '', //开户行市
                bankTownId: '', //开户行乡镇
                thirdStatus: '', //支付审核状态
                alipayStatus: '', //支付宝支付审核状态
                wxpayStatus: '', //微信支付审核状态
                resultMsg: '', //响应报文
                isSign: '', //是否签名 0否 1是
                signPic: '', //签名图片
                contractUrl: '', //合同地址
                otherInfor: '', //其他补充资料
                wxpayNo: '',
                wxpayNo1: '',
                alipayNo: '',
                alipayNo1: '',
                wxpayApplyQrcode: '',
                wxpayConfirmQrcode: '',
                alipayApplyQrcode: '',
                alipayConfirmQrcode: '',
                ysAreaId: '',
                ysCityId: '',
                ysProvinceId: '',
                mccCode: '',
                mccCodeName: '',
                needQualification: "",
                qualificationStatus: '',
                qualificationPics: '',
                changeRequestimg: '', //变更申请图片
                thirdPartyType: '',//三方类型,1:银盛,2:快付
                servicePhone:'',//客服电话
                serviceEmail:'',//商户邮箱
                deviceNo:"",//终端号
            },
            rules: {
                orgType: [{ required: true, message: '组织类型 1小微 2企业 3个体不能为空', trigger: 'blur' }],
                licensePic: [{ required: true, message: '营业执照图片不能为空', trigger: 'blur' }],
                licenseProvinceId: [{ required: true, message: '营业执照省不能为空', trigger: 'blur' }],
                licenseCityId: [{ required: true, message: '营业执照市不能为空', trigger: 'blur' }],
                licenseAreaId: [{ required: true, message: '营业执照区不能为空', trigger: 'blur' }],
                licenseTownId: [{ required: true, message: '营业执照乡镇不能为空', trigger: 'blur' }],
                licenseName: [{ required: true, message: '营业执照名称不能为空', trigger: 'blur' }],
                licenseAddress: [{ required: true, message: '营业执照地址不能为空', trigger: 'blur' }],
                licenseNumber: [{ required: true, message: '社会统一信用代码不能为空', trigger: 'blur' }],
                licenseStartTime: [{ required: true, message: '营业执照有效开始日期不能为空', trigger: 'blur' }],
                licenseEndTime: [{ required: true, message: '营业执照有效结束日期不能为空', trigger: 'blur' }],
                licenseRange: [{ required: true, message: '营业执照经营范围不能为空', trigger: 'blur' }],
                personName: [{ required: true, message: '法人姓名不能为空', trigger: 'blur' }],
                personMobile: [{ required: true, message: '法人手机号不能为空', trigger: 'blur' }],
                idCard: [{ required: true, message: '身份证号不能为空', trigger: 'blur' }],
                idCardStartTime: [{ required: true, message: '身份证有效开始日期不能为空', trigger: 'blur' }],
                idCardEndTime: [{ required: true, message: '身份证有效结束日期不能为空', trigger: 'blur' }],
                idCardFacade: [{ required: true, message: '身份证正面图片不能为空', trigger: 'blur' }],
                idCardBack: [{ required: true, message: '身份证背面图片不能为空', trigger: 'blur' }],
                idCardAddress: [{ required: true, message: '身份证地址不能为空', trigger: 'blur' }],
                bankAccount: [{ required: true, message: '银行账号不能为空', trigger: 'blur' }],
                bankHolder: [{ required: true, message: '银行卡持有人不能为空', trigger: 'blur' }],
                bankMobile: [{ required: true, message: '银行预留手机号不能为空', trigger: 'blur' }],
                bankCardFacade: [{ required: true, message: '银行卡正面图片不能为空', trigger: 'blur' }],
                bankCardBack: [{ required: true, message: '银行卡背面图片不能为空', trigger: 'blur' }],
                bankAccountVoucher: [{ required: true, message: '对公账户凭证不能为空', trigger: 'blur' }],
                bankName: [{ required: true, message: '银行名称不能为空', trigger: 'blur' }],
                bankSubbranch: [{ required: true, message: '开户支行名称不能为空', trigger: 'blur' }],
                bankProvinceId: [{ required: true, message: '开户行省不能为空', trigger: 'blur' }],
                bankCityId: [{ required: true, message: '开户行市不能为空', trigger: 'blur' }],
                bankAreaId: [{ required: true, message: '开户行市不能为空', trigger: 'blur' }],
                bankTownId: [{ required: true, message: '开户行乡镇不能为空', trigger: 'blur' }],
                thirdStatus: [{ required: true, message: '支付审核状态不能为空', trigger: 'blur' }],
                alipayStatus: [{ required: true, message: '支付宝支付审核状态不能为空', trigger: 'blur' }],
                wxpayStatus: [{ required: true, message: '微信支付审核状态不能为空', trigger: 'blur' }],
                isSign: [{ required: true, message: '是否签名 0否 1是不能为空', trigger: 'blur' }],
                signPic: [{ required: true, message: '签名图片不能为空', trigger: 'blur' }],
                contractUrl: [{ required: true, message: '合同地址不能为空', trigger: 'blur' }],
                otherInfor: [{ required: true, message: '其他补充资料 如烟草经营许可证不能为空', trigger: 'blur' }],
                ysAreaId: [{ required: true, message: '区不能为空', trigger: 'blur' }],
                ysCityId: [{ required: true, message: '市不能为空', trigger: 'blur' }],
                ysProvinceId: [{ required: true, message: '省不能为空', trigger: 'blur' }],
                mccCode: [{ required: true, message: 'mcc编码不能为空', trigger: 'blur' }],
                needQualification: [{ required: true, message: '是否需要其他资质不能为空', trigger: 'blur' }],
                qualificationStatus: [{ required: true, message: '审核状态不能为空', trigger: 'blur' }],
            },
            getCity: false,//区别是不是get来的
            getArea: false,//区别是不是get来的
            street: false,
            getCity2: false,//区别是不是get来的
            getArea2: false,//区别是不是get来的
            street2: false,
            ysGetCity: false,//区别是不是get来的
            ysGetArea: false,//区别是不是get来的
            showDialog: false,
            imageSrc: '',
            srcList: [''],
            provinceIdList: [], //省信息
            cityIdList: [], //市信息
            areaIdList: [], //区信息
            cityIdList2: [], //市信息
            areaIdList2: [], //区信息
            streetIdList: [],
            auditStatusEnumList: [],
        };
    },
    created() {
        this.getEnum();
        this.getAddress(1);
    },
    mounted() {
        this.getBrandList();
    },
    methods: {
        addHFPayFn(row){
            this.$confirm('确认要加入汇付支付吗?', '提示', {
                type: 'warning'
            }).then(()=>{
                this.loading = true;
                get('/shop/storeorginfo/huiFuPayAdd',{storeId:row.storeId}).then(res=>{
                    this.loading = false;
                    if(res.code == 200){
                        this.$message({
                            message: res.msg,
                            type: res.success ? 'success' :'error',
                            duration: 2000
                        });
                        if(res.success){
                            this.getBrandList()  
                        }
                    }   
                })
            })
        },
        addKFPayFn(row){
            this.$confirm('确认要加入快付支付吗?', '提示', {
                type: 'warning'
            }).then(()=>{
                this.loading = true;
                get('/shop/storeorginfo/kuaiFuPayAdd',{storeId:row.storeId}).then(res=>{
                    this.loading = false;
                    if(res.code == 200){
                        this.$message({
                            message: res.msg,
                            type: res.success ? 'success' :'error',
                            duration: 2000
                        });
                        if(res.success){
                            this.getBrandList()  
                        }
                    }   
                })
            })
        },
        updateDrawer(val){
            this.drawer=val
            this.getBrandList()
        },
        //  查看
          checkShopStoreOrgInfo(row){
            this.incomingData(row)
            this.disabled = true
            this.drawer = true
        },
        // 修改
        editShopStoreOrgInfo(row){
               this.incomingData(row)
               this.disabled = false
               this.drawer = true
        },  
        // 查询进件接口
         incomingData(row){
             get('/shop/store/findById',{
                storeId: row.storeId
                // storeId: 'ec7ced954ca640d186296eafbb795153'
            }).then((res)=>{
                if(res.code == 200){
                    this.orgObj = res.data.org
                    this.storeObj = res.data.store
                }
            })
        },
        copyHuiFuId(huiFuId){
            if (navigator.clipboard && navigator.clipboard.writeText) {
                // 使用现代 Clipboard API
                navigator.clipboard.writeText(huiFuId).then(() => {
                    this.$message.success('复制成功');
                }).catch(() => {
                    this.$message.error('复制失败');
                });
            } else {
                // 降级方案
                const textarea = document.createElement('textarea');
                textarea.value = huiFuId;
                textarea.style.position = 'fixed';
                textarea.style.opacity = '0';
                document.body.appendChild(textarea);
                textarea.select();
                try {
                    document.execCommand('copy');
                    this.$message.success('复制成功');
                } catch (err) {
                    this.$message.error('复制失败');
                } finally {
                    document.body.removeChild(textarea);
                }
            }
        },
       radioThis(item){
            this.shopStoreOrginfo.mccCode = item.mccCd
            this.shopStoreOrginfo.mccCodeName = item.mchTypeNm
        },
        getMccCode(index){
            let obj = {
                orgType:index,
            }
            get("/shop/store/getYsMccCode" , obj).then((res)=>{
                if(res.success){
                    this.mccCodeList = res.mccInfoList;
                    this.$nextTick(()=>{
                        this.$refs.mccCode.init(this.mccCodeList)
                    })
                }
            })
        },
        submitForm() {
            delete this.shopStoreOrginfo.licenseProvince
            delete this.shopStoreOrginfo.licenseCity
            delete this.shopStoreOrginfo.licenseArea
            delete this.shopStoreOrginfo.licenseTown
            delete this.shopStoreOrginfo.bankProvince
            delete this.shopStoreOrginfo.bankCity
            delete this.shopStoreOrginfo.bankArea
            delete this.shopStoreOrginfo.bankTown
            delete this.shopStoreOrginfo.store
            delete this.shopStoreOrginfo.user

            this.shopStoreOrginfo.qualificationPics  = this.albumList;
            this.loading = true;
            if (this.shopStoreOrginfoState == 'add') {
                this.$refs.shopStoreOrginfoForm.validate((valid) => {
                    if (valid) {
                        post(`/shop/storeorginfo/add`, { ...this.shopStoreOrginfo }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.showDialog = false;
                                this.resetShopStoreOrgInfoList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.shopStoreOrginfoState == 'edit') {
                this.$refs.shopStoreOrginfoForm.validate((valid) => {
                    if (valid) {
                        post(`/shop/storeorginfo/edit`, { ...this.shopStoreOrginfo }).then((res) => {
                            this.loading = false;
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.showDialog = false;
                                // this.resetShopStoreOrgInfoList();
                                this.resetDialog();
                                 
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    
                    }else{
                           this.$message({
                                showClose: true,
                                message: '信息请填写完整',
                                type: 'warning'
                                }); 
                    }
                });
            }
        },
        // 查看
        // checkShopStoreOrgInfo(shopStoreOrginfoId) {
        //     this.currentShopStoreOrgInfoId = shopStoreOrginfoId;
        //     this.getShopStoreOrgInfoById();
        //     this.showDialog = true;
        //     this.disabledShow = true;
        //     this.shopStoreOrginfoState = 'check';
        // },
        // 编辑
        // editShopStoreOrgInfo(shopStoreOrginfoId) {
        //     this.currentShopStoreOrgInfoId = shopStoreOrginfoId;
        //     this.getShopStoreOrgInfoById();
        //     this.showDialog = true;
        //     this.disabledShow = false;
        //     this.shopStoreOrginfoState = 'edit';
        // },
        // 获取对应地址
        getAddress(type, id=null) {
            get("/mpp/utils/findAreaList",{areaType:type,pid:id}).then((res)=>{
                if(res.success){
                    let array = []
                    for (let listElement of res.list) {
                        listElement.id = String(listElement.id)
                        array.push(listElement)
                    }
                    if(type == 1){
                        this.provinceIdList = array
                    }else if(type == 2){
                        this.cityIdList = array
                    }else if(type == 3){
                        this.areaIdList = array
                    }else if(type == 4){
                        this.streetIdList = array
                    }
                }
            })
        },
        // 获取对应地址
        getAddress2(type, id=null) {
            get("/mpp/utils/findAreaList",{areaType:type,pid:id}).then((res)=>{
                if(res.success){
                    let array = []
                    for (let listElement of res.list) {
                        listElement.id = String(listElement.id)
                        array.push(listElement)
                    }
                    if(type == 2){
                        this.cityIdList2 = array
                    }else if(type == 3){
                        this.areaIdList2 = array
                    }else if(type == 4){
                        this.streetIdList2 = array
                    }
                }
            })
        },
        beforeAvatarUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 50;
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 50MB!');
            }
            return isLt2M;
        },
         //上传成功
        handleSuccess(response, file, fileList) {
            this.temporaryList.push(file.response.url);
            this.albumList = this.temporaryList.join('|');
        },
        handleRemove(file, fileList) {
           for (let i = 0; i < this.temporaryList.length; i++) {
               console.log(file.url == this.temporaryList[i])
               if (file.url == this.temporaryList[i]) {
                   this.temporaryList.splice(i, 1);
               }
           }
           this.albumList = this.temporaryList.join('|');
        },
        beforeImageUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 50;
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 50MB!');
            }
            return isLt2M;
        },
        //上传缩略图
        uploadImage11(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.signPic = res.url;
                }
            });
        },
        uploadImage12(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.contractUrl = res.url;
                }
            });
        },
        uploadImage21(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.licensePic = res.url;
                }
            });
        },
        uploadImage31(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.idCardFacade = res.url;
                }
            });
        },
        uploadImage32(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.idCardBack = res.url;
                }
            });
        },
        uploadImage41(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.bankCardFacade = res.url;
                }
            });
        },
        uploadImage42(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.bankCardBack = res.url;
                }
            });
        },
        // 修改
        getShopStoreOrgInfoById() {
            get(`/shop/storeorginfo/get`, { id: this.currentShopStoreOrgInfoId }).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo = { ...this.shopStoreOrginfo, ...res.shopStoreOrginfo };
                    this.fileList = [];
                    this.albumList = [];
                    this.temporaryList = [];
                    if (res.shopStoreOrginfo.qualificationPics) {
                        let str = res.shopStoreOrginfo.qualificationPics;
                        var list = str.split('|');

                        this.fileList = list.map((item) => {
                            return {
                                name: item,
                                url: item
                            };
                        });
                        for (let item of list) {
                            this.temporaryList.push(item);
                        }
                        this.albumList = '';
                        this.albumList = this.temporaryList.join('|');
                    }else{
                        this.shopStoreOrginfo.qualificationPics = ""
                    }
                    this.getCity = true;
                    this.getArea = true;
                    this.street = true;
                    this.getCity2 = true;
                    this.getArea2 = true;
                    this.street2 = true;

                    this.ysGetCity = true;
                    this.ysGetArea = true;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        closeDialog() {
            this.showDialog = false;
            this.shopStoreOrginfo = {
                userId: '', //用户id
                storeId: '', //门店id
                subAccount: '', //子商户号
                orgType: '', //组织类型 1小微 2企业 3个体
                licensePic: '', //营业执照图片
                licenseProvinceId: '', //营业执照省
                licenseCityId: '', //营业执照市
                licenseAreaId: '', //营业执照区
                licenseTownId: '', //营业执照乡镇
                licenseName: '', //营业执照名称
                licenseAddress: '', //营业执照地址
                licenseNumber: '', //社会统一信用代码
                licenseStartTime: '', //营业执照有效开始日期
                licenseEndTime: '', //营业执照有效结束日期
                licenseRange: '', //营业执照经营范围
                personName: '', //法人姓名
                personMobile: '', //法人手机号
                idCard: '', //身份证号
                idCardStartTime: '', //身份证有效开始日期
                idCardEndTime: '', //身份证有效结束日期
                idCardFacade: '', //身份证正面图片
                idCardBack: '', //身份证背面图片
                idCardAddress: '', //身份证地址
                bankAccount: '', //银行账号
                bankHolder: '', //银行卡持有人
                bankMobile: '', //银行预留手机号
                bankCardFacade: '', //银行卡正面图片
                bankCardBack: '', //银行卡背面图片
                bankAccountVoucher: '', //对公账户凭证
                bankName: '', //银行名称
                bankSubbranch: '', //开户支行名称
                bankProvinceId: '', //开户行省
                bankCityId: '', //开户行市
                bankAreaId: '', //开户行市
                bankTownId: '', //开户行乡镇
                thirdStatus: '', //支付审核状态
                alipayStatus: '', //支付宝支付审核状态
                wxpayStatus: '', //微信支付审核状态
                resultMsg: '', //响应报文
                isSign: '', //是否签名 0否 1是
                signPic: '', //签名图片
                contractUrl: '', //合同地址
                otherInfor: '', //其他补充资料 如烟草经营许可证
                wxpayNo: '',
                wxpayNo1: '',
                alipayNo: '',
                alipayNo1: '',
                wxpayApplyQrcode: '',
                wxpayConfirmQrcode: '',
                alipayApplyQrcode: '',
                alipayConfirmQrcode: '',
                ysProvinceId: '',
                ysCityId: '',
                ysAreaId: '',
                mccCode: '',
                mccCodeName: '',
                needQualification: "",
                qualificationStatus: '',
                qualificationPics: '',
                servicePhone:'',
                serviceEmail:'',
                deviceNo:""
            };
            this.albumList = [];
            this.temporaryList = [];
            this.fileList = [];
        },
        // 获取枚举
        getEnum(){
            get('/shop/utils/getEnum',{
                enumType: "store_org_type_status"
            }).then((res)=>{
                if(res.success){
                    this.storeOrgTypeStatusEunmList = res.enumList;
                }
            })
            get('/mpp/utils/getEnum', {
                enumType: 'audit_status'
            }).then((res) => {
                if(res.success){
                    this.auditStatusEnumList = res.enumList;
                }
            });

            get('/shop/utils/getEnum', {
                enumType: 'audit_v3_status'
            }).then((res) => {
                if(res.success){
                    this.auditStatusList = res.enumList;
                }
            });
        },
        // 大图预览
        updateSrcList(src) {
            this.srcList[0] = src
        },
        getImage(url){
            this.srcList = [''];
            this.imageSrc = url;
            this.srcList[0] = url;
            this.$refs.images.showViewer = true;
        },
        seeImages(){
            this.srcList = this.temporaryList
            this.$refs.images.showViewer = true;
        },
        getSearchValueUser(val){
            this.queryForm.userId = val;
        },
        //汇付进件
        incoming(row){
            this.$confirm('确认要进行汇付进件吗?', '提示', {
                type: 'warning'
            }).then(()=>{
                this.loading = true;
                get('/shop/storeorginfo/huiFuRegister',{storeId : row.storeId}).then(res=>{
                    this.loading = false;
                      if(res.success){
                        this.$message({
                            message: res.msg,
                            type: 'success',
                            duration: 2000
                        });
                       this.getBrandList()
                    }
                })
            })
        },
 
       refreshShopMoneyFlowList() {
            this.resetShopBrandList();
            this.getBrandList();
        },
        thousandSeparator(value) {
            if (!value && value !== 0) return '';
                const num = Number(value);
                if (isNaN(num)) return value;

                // 如果大于等于1000，使用千分位格式化
                if (num >= 1000) {
                return num.toLocaleString('en-US');
                }
                return num;
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopBrandList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopBrandList = [];
        },
      
        refreshShopBrandList() {
            this.resetShopBrandList();
            this.getBrandList();
        },
        resetDialog() {
            this.queryForm = {
                  licenseName: "",
                  userId:"",//用户ID
                  licenseNumber: "",
                  storeId: "",
                  orgType: "", //组织类型：1小微 2企业 3个体
                  personName: "", //法人姓名
                  personMobile: "", //法人手机
            };
            this.resetShopBrandList();
            this.getBrandList();
        },
        // 列表数据请求
        getBrandList() {
                this.loading = true;
                get('/shop/storeorginfo/page',{ 
                         ...this.queryForm,
                         pageSize: this.pageSize,
                         pageNum: this.currentPage
                        }).then(res => {
                    this.loading = false;
                    if (res.success) {
                        this.shopBrandList = res.pageInfo.list
                        this.totalNum = res.pageInfo.total

                    }else{
                        this.$message.error(res.data.msg);
                    }
                })
            
        },
           //商户业务开通
           merchantBusinessActivation(row){
               this.loading = true;
               get('/shop/storeorginfo/registerProduct',{storeId:row.storeId}).then(res=>{
                    this.loading = false;
                    if(res.success){
                        this.$message({
                            message: res.msg,
                            type: 'info',
                            duration: 2000
                        });
                        this.getBrandList()  
                    }else{
                        this.$message({
                            message: res.msg,
                            type: 'danger',
                            duration: 2000
                        });
                    }     
               })
           },
           //商户展示
           merchantDisplay(row){
               get('/shop/storeorginfo/modifyStore',{storeId:row.storeId}).then(res=>{
                     if(res.success){
                        this.$message({
                            message: res.msg,
                            type: 'info',
                            duration: 2000
                        });
                        this.getBrandList()  
                     }else{
                        this.$message({
                            message: res.msg,
                            type: 'danger',
                            duration: 2000
                        });
                    }       
               })
           },
           basicDataStatus(type,row){
            this.loading = true;
               if(type == 1){
                      postJson('/shop/storeorginfo/basicDataStatus',{storeId:row.storeId,applyNoName:'jj'}).then((res) => { 
                            this.loading = false;
                            if(res.success){
                              this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.getBrandList()
                            }else{
                              this.$message({
                                    message: res.msg,
                                    type: 'danger',
                                    duration: 2000
                                });
                            }
                      });
               } else { 
                       postJson('/shop/storeorginfo/basicDataStatus',{storeId:row.storeId,applyNoName:'product'}).then((res) => { 
                            this.loading = false;
                            if(res.success){
                                this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.getBrandList()
                            }else{
                                this.$message({
                                        message: res.msg,
                                        type: 'danger',
                                        duration: 2000
                                    });
                            }
                      });
               }

           },
        resetQueryFrom() {
            this.getBrandList();
        },
        
        handleSelectionChange(value) {
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getBrandList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getBrandList();
        },
    }
};
</script>

<!-- 添加全局样式 -->
<style lang="scss">
.el-image-viewer__img {
    background-color: #fff !important;
}
</style>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-evenly;
    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }
    .primary{
        background-color: #409eff;
        color: #fff;
        border-radius: 4px;
        height: 28px;
        line-height: 28px;
        margin-top: 15px;
        padding: 0 15px;
        // min-width: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .danger{
        background-color: #f56c6c;
        color: #fff;
        border-radius: 4px;
        height: 28px;
        line-height: 28px;
    }
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.logo-img {
    margin-left: 50%;
    transform: translate(-50%, 0);
}
.count{
    margin-right:1.5625vw;
}
</style>
